"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOLAdminIdentity = void 0;
/**
 * The AWS Cognito APIs only allow for lookups using a single field: username<br/>
 * We are attempting to abstract it away by setting username to one of these fields<br/>
 * The order of precedence is:<br/>
 * - uinfin<br/>
 * - agencyUserId<br/>
 * - email<br/>
 */
class MOLAdminIdentity {
    constructor(props) {
        Object.assign(this, props);
    }
}
exports.MOLAdminIdentity = MOLAdminIdentity;
//# sourceMappingURL=MOLAdminIdentity.js.map